import React from 'react';
import Link from 'next/link';

interface SuperLinkProps extends Omit<React.HTMLProps<HTMLAnchorElement>, 'href'> {
  href: string;
  children: React.ReactNode;
}

export const SuperLink = ({
  href,
  children,
  ...props
}: SuperLinkProps): React.ReactElement => {
  return (
    <Link href={href || ''} passHref>
      <a href={href} {...props}>
        { children }
      </a>
    </Link>
  );
};
